import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import MangaSection from "./components/MangaSection";
import CategoryGrid from "./components/CategoryGrid";
import { getHotManga, getLatestManga, getCompletedManga } from "@/mocks/manga";

export default function Home() {
  const hotManga = getHotManga();
  const latestManga = getLatestManga();
  const completedManga = getCompletedManga();

  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "迷妹漫画",
    url: "https://mimeimanga.com/",
    description: "迷妹漫画网聚合漫画全集、完结漫画与漫画完整版资源，提供完结漫画大全一站式在线浏览，支持竖屏连续滚动阅读。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://mimeimanga.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "迷妹漫画",
    url: "https://mimeimanga.com/",
    description: "迷妹漫画是专业的漫画全集在线阅读平台，提供完结漫画大全，支持竖屏连续滚动阅读体验。",
  };

  const webPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "迷妹漫画 - 首页",
    description: "漫画全集完结完整版在线看，完结漫画大全尽在迷妹漫画网免费下拉式阅读。",
    url: "https://mimeimanga.com/",
    isPartOf: { "@type": "WebSite", name: "迷妹漫画", url: "https://mimeimanga.com/" },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }} />

      <div className="min-h-screen bg-background-50 font-body">
        <Navbar />

        <main>
          {/* Hero */}
          <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20manga%20reading%20scene%20with%20floating%20manga%20pages%20and%20soft%20magical%20glow%2C%20cozy%20reading%20nook%20atmosphere%2C%20warm%20coral%20and%20peach%20gradient%20background%2C%20dreamy%20ethereal%20lighting%2C%20Japanese%20manga%20aesthetic%2C%20whimsical%20floating%20elements%2C%20soft%20focus%2C%20cinematic%20composition&width=1600&height=900&seq=mimei-hero-bg&orientation=landscape"
              alt="迷妹漫画 - 漫画全集在线免费阅读"
              className="w-full h-full object-cover object-center"
              title="迷妹漫画 - 漫画全集完结完整版在线看"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
              <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
                漫画全集，一网打尽
              </h1>
              <p className="text-sm md:text-base text-background-50/85 max-w-xl mb-6 leading-relaxed">
                聚合海量完结漫画与漫画完整版资源，支持竖屏连续滚动阅读。完结漫画大全，让漫画迷一次性补完大结局。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/category/romance"
                  className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  开始阅读
                </Link>
                <Link
                  to="/about"
                  className="px-6 py-2.5 rounded-full bg-background-50/20 text-background-50 border border-background-50/30 text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Hot manga */}
          <MangaSection
            title="热门推荐"
            subtitle="千万漫迷的共同选择，口碑爆棚的人气漫画"
            mangaList={hotManga}
          />

          {/* Category grid */}
          <CategoryGrid />

          {/* Latest updates */}
          <MangaSection
            title="最近更新"
            subtitle="追更不停歇，最新话第一时间上线"
            mangaList={latestManga}
          />

          {/* Completed manga */}
          <MangaSection
            title="完结漫画大全"
            subtitle="一次性看个过瘾，大结局已全部收录"
            mangaList={completedManga}
          />

          {/* Features */}
          <section className="bg-background-100 py-12 md:py-16">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 text-center mb-8">为什么选择迷妹漫画？</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: "ri-book-read-line", title: "海量资源", desc: "漫画全集、完结漫画、漫画完整版，一站式收录" },
                  { icon: "ri-scroll-to-bottom-line", title: "下拉式阅读", desc: "支持竖屏连续滚动阅读，沉浸式追漫体验" },
                  { icon: "ri-speed-line", title: "极速更新", desc: "最新章节第一时间上线，追更永不掉队" },
                  { icon: "ri-device-line", title: "全设备适配", desc: "手机、平板、电脑完美兼容，随时随地看漫画" },
                ].map((feat, i) => (
                  <div key={i} className="text-center p-5 rounded-lg bg-background-50">
                    <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                      <i className={`${feat.icon} text-primary-600 text-lg`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 text-center mb-8">常见问题</h2>
            <div className="max-w-3xl mx-auto space-y-3">
              {[
                { q: "迷妹漫画网上的漫画都是免费看的吗？", a: "是的！迷妹漫画网上的所有漫画全集、完结漫画和漫画完整版资源均提供免费在线阅读，无需付费订阅。" },
                { q: "什么是下拉式漫画阅读模式？", a: "下拉式漫画是一种竖屏连续滚动阅读方式，您只需向下滑动即可无缝阅读下一话，无需频繁翻页，阅读体验更加流畅沉浸。" },
                { q: "完结漫画大全包含哪些类型的漫画？", a: "迷妹漫画的完结漫画大全涵盖恋爱、奇幻、悬疑、古风、都市、搞笑、动作、恐怖等全品类漫画，所有已完结的漫画完整版均已收录。" },
                { q: "漫画更新频率是怎样的？", a: "我们紧跟原作连载进度，连载中的漫画会在最新话发布后第一时间更新上线，确保您不会错过任何精彩内容。" },
              ].map((faq, i) => (
                <details key={i} className="group rounded-lg bg-background-100 border border-background-200/70">
                  <summary className="flex items-center justify-between px-5 py-3.5 cursor-pointer list-none text-sm font-medium text-foreground-800">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="px-5 pb-4 text-xs text-foreground-600 leading-relaxed">{faq.a}</p>
                </details>
              ))}
            </div>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "FAQPage",
                  mainEntity: [
                    { "@type": "Question", name: "迷妹漫画网上的漫画都是免费看的吗？", acceptedAnswer: { "@type": "Answer", text: "是的！迷妹漫画网上的所有漫画全集、完结漫画和漫画完整版资源均提供免费在线阅读，无需付费订阅。" } },
                    { "@type": "Question", name: "什么是下拉式漫画阅读模式？", acceptedAnswer: { "@type": "Answer", text: "下拉式漫画是一种竖屏连续滚动阅读方式，您只需向下滑动即可无缝阅读下一话，无需频繁翻页，阅读体验更加流畅沉浸。" } },
                    { "@type": "Question", name: "完结漫画大全包含哪些类型的漫画？", acceptedAnswer: { "@type": "Answer", text: "迷妹漫画的完结漫画大全涵盖恋爱、奇幻、悬疑、古风、都市、搞笑、动作、恐怖等全品类漫画，所有已完结的漫画完整版均已收录。" } },
                    { "@type": "Question", name: "漫画更新频率是怎样的？", acceptedAnswer: { "@type": "Answer", text: "我们紧跟原作连载进度，连载中的漫画会在最新话发布后第一时间更新上线，确保您不会错过任何精彩内容。" } },
                  ],
                }),
              }}
            />
          </section>

          {/* CTA */}
          <section className="relative w-full py-16 md:py-20 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20manga%20library%20background%20with%20bookshelves%20and%20soft%20reading%20lamps%2C%20cozy%20atmosphere%2C%20warm%20amber%20and%20coral%20gradient%20lighting%2C%20dreamy%20bookstore%20vibe%2C%20soft%20focus%20background%2C%20cinematic%20composition&width=1600&height=600&seq=mimei-cta-bg&orientation=landscape"
              alt=""
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
            <div className="relative z-10 text-center px-4 w-full">
              <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50 mb-3">准备好开启你的漫画之旅了吗？</h2>
              <p className="text-sm md:text-base text-background-50/80 mb-6 max-w-lg mx-auto">数千部漫画全集等你来探索，马上开始你的沉浸式阅读体验吧！</p>
              <Link
                to="/category/romance"
                className="inline-block px-8 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                立即免费阅读
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}